import { connect } from 'react-redux';
import { reduxForm, change, formValueSelector } from 'redux-form';
import { fetchSalesInvoiceDetail, fetchSalesInvoiceCompletedDetail, fetchCustomerItem } from '../../actions/salesInvoice_actions';
import { createSalesReturn, editSalesReturn, fetchSalesReturnDetail } from '../../actions/sales_actions';
import CreditForm from '../../components/Returns/creditForm';

let creditForm = reduxForm({
  form: 'creditForm',
})(CreditForm);

const selector = formValueSelector('creditForm');

function mapStateToProps(state) {
    const Days = selector(state, 'Days');
    const FormTypes = selector(state, 'FormTypes');
    const FromDate = selector(state, 'FromDate');
    const ToDate = selector(state, 'ToDate');
    const Customers = selector(state, 'Customers');
    const Item = selector(state, 'Item');

    return {
      Days,
      FormTypes,
      FromDate,
      ToDate,
      Customers,
      Item,

      currentSalesInvoice: state.salesInvoice.currentSalesInvoice,
      salesInvoiceDetail: state.salesInvoice.currentSalesInvoiceDetail,
      salesReturnDetail: state.salesInvoice.salesReturnDetail,
      initialValues: state.salesInvoice.salesReturnDetail,
      currentCustomer: state.customers.currentCustomer,
      customerItem: state.salesInvoice.customerItem
    }
}

export default connect(mapStateToProps, { fetchSalesInvoiceDetail, fetchSalesInvoiceCompletedDetail, createSalesReturn, editSalesReturn, fetchSalesReturnDetail, fetchCustomerItem })(creditForm);



// WEBPACK FOOTER //
// ./master/jsx/containers/Returns/creditForm.jsx